<template>
  <div class="loginBGC">
    <img src="../../assets/img/backgroundImg.jpeg" class="backgroundImg">
    <div class="loginContainer">
      <div class="loginLeft">
        <p class="loginTitle">登录</p>
        <p>填写你的平台管理员信息</p>
        <div>
          <div class="d1d4bgc">
            <el-input prefix-icon="el-icon-user-solid"
                    class="input" v-model="user.username" placeholder="请输入管理员账号"></el-input>
          </div>
        </div>
        <div>
          <div class="d1d4bgc">
            <el-input prefix-icon="el-icon-lock"
                    class="input" v-model="user.password" type="password" placeholder="请输入登录密码"></el-input>
          </div>
        </div>
        <el-button @click="login" style="margin-left: 44px;margin-top: 10px" type="primary" size="medium">登录</el-button>
      </div>
      <div class="loginRight">
        <img id="logo" src="../../assets/img/top-right-logo-b.svg">
        <p class="introduce">心乡农，始于2020年，发展至今。专注乡产集采，连接城乡生活，构建可持续生态。</p>
        <p class="loginBottomText">© 2020-现在 xsalo.cn，All rights reserved</p>
      </div>
    </div>
  </div>
</template>

<script>
  import {adminLogin, newVue} from "../../network/admin";
  import {errorMsg} from "../../utils/util";

  export default {
    name: "Login",
    data(){
      return{
        user:{}
      }
    },
    created() {
      newVue.obj = this;
    },
    methods:{
      login(){
        if(this.user.username==null||this.user.username==''){
          errorMsg("请填写用户名")
          return
        }
        if(this.user.password==null||this.user.password==''){
          errorMsg("请输入密码")
          return
        }
        adminLogin(this.user).then(res => {
          if (res.code==200){
            sessionStorage["isLogin"] = true;
            sessionStorage["jwtToken"] = "Bearer "+res.data;
            sessionStorage["adminId"] = res.message;
            this.common.loginInfo.isLogin = true;
            this.common.loginInfo.jwtToken = "Bearer "+res.data;
            this.$router.push("/xsalocenter")
          }
        })
      }
    }
  }
</script>

<style scoped>
  .loginBottomText{
    color: #ffffff;
    font-size: 0.675rem;
    font-weight: 300;
    line-height: 1.5;
    text-align: center;
    position: absolute;
    bottom: 10px;
    padding-left: 10%;
  }
  #logo{
    margin-top: 60px;
    padding-top: 20px;
    padding-bottom: 20px;
    width: 200px;
    height: 90px;
  }
  .input{
    width: 280px;
  }
  .d1d4bgc{
    font-size: 20px;
    line-height: 35px;
    margin-bottom: 15px;
    margin-top: 15px;
    margin-left: 44px;
  }
  .loginBGC{
    width: 100%;
    height: 100vh;
    background-color: #e4e5e6;
  }
  .loginContainer{
    display:flex;
    position: relative;
    flex-direction: row;
    top: calc(50% - 195px);
    left: calc(50% - 365px);
    width: 730px;
    height: 390px;
  }
  .loginLeft{
    color: #a3a9ae;
    font-size: 0.875rem;
    line-height: 1.5;
    width: 408px;
    height: 330px;
    background-color: white;
    padding-top: 60px;
  }
  .loginTitle{
    color: black;
    font-size: 38px;
  }
  .loginLeft p{
    margin-left: 44px;
    margin-top: 0;
    margin-bottom: 0;
  }

  .loginRight{
    position: relative;
    width: 282px;
    height: 100%;
    background-color: #72C3A9;
    text-align: center;
    padding-left: 20px;
    padding-right: 20px;
  }
  .title{
    margin-top: 60px;
    font-size: 2rem;
    color: #ffffff;
    margin-bottom: 0.5rem;
    font-weight: 500;
    line-height: 1.1;
    font-family: inherit;
  }
  .introduce{
    color: #ffffff;
    font-size: 0.875rem;
    font-weight: 300;
    line-height: 1.5;
  }
  .backgroundImg{
    width: 100%;
    height: 100%;
    margin: 0;
    position: absolute;
    left: 0;
    z-index: 0;
  }
</style>
